import { Box, FormControlLabel, Radio, RadioGroup, Skeleton, Typography } from '@mui/material';

import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomCard from 'components/shared/CustomCard/CustomCard';
import CustomModal from 'components/shared/CustomModal/CustomModal';
import { ModalAction } from 'model/modal.model';
import { Dispatch, useState } from 'react';
import zeplinColor from 'theme/Color';

export const DealSelectionModal = ({
  isModalOpen,
  modalDispatch,
  onSelect,
}: {
  isModalOpen: boolean;
  modalDispatch: Dispatch<ModalAction>;
  onSelect: (args: any) => void;
}) => {
  const [loading, setLoading] = useState(false);
  const [dealTypeSelected, setDealTypeSelected] = useState('');

  const handleTaskType = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDealTypeSelected(event.target.value);
  };

  const dealType = [
    'Commercial/Endorsement',
    'Event_Appearance',
    'Event_Owned',
    'Content/Production',
    'Licensing/IP',
    'Equity/Investment',
    'Branded Entertainment',
  ];

  return (
    <CustomModal
      handleClose={() => modalDispatch({ type: 'CLOSE', payload: 'selectedDealType' })}
      open={isModalOpen}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: '24px',
            backgroundColor: zeplinColor.Neutral1,
            width: { xs: '280px', xl: '312px' },
            boxShadow: 'rgba(0, 0, 0, 0.15)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: '18px', xl: '24px' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                }}
              >
                <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                  Select Deal Type
                </Typography>
              </Box>
              <img
                src={'/assets/cross.svg'}
                alt='logo'
                onClick={() => modalDispatch({ type: 'CLOSE', payload: 'selectedDealType' })}
                style={{ cursor: 'pointer' }}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '10px', xl: '16px' },
              }}
            >
              <RadioGroup
                aria-labelledby='demo-controlled-radio-buttons-group'
                name='controlled-radio-buttons-group'
                value={dealTypeSelected}
                onChange={handleTaskType}
                sx={{
                  color: zeplinColor.BasicBlack,
                  '&.Mui-checked': {
                    color: zeplinColor.BasicBlack,
                  },
                  padding: '0px',
                }}
              >
                {loading ? (
                  <Skeleton
                    variant='text'
                    sx={{
                      width: '100%',
                    }}
                  />
                ) : (
                  dealType.map((name) => (
                    <FormControlLabel
                      key={name}
                      value={name}
                      control={
                        <Radio
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />
                      }
                      label={name}
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '& .MuiButtonBase-root': {
                          color: zeplinColor.BasicBlack,
                        },
                        padding: '0px',
                      }}
                    />
                  ))
                )}
              </RadioGroup>
            </Box>
            <CustomButton
              disabled={!dealTypeSelected}
              onClick={() => {
                modalDispatch({ type: 'OPEN', payload: 'drawer' });
                modalDispatch({ type: 'CLOSE', payload: 'selectedDealType' });
                onSelect(dealTypeSelected);
              }}
              variant='contained'
              color={'primary'}
              style={{
                width: '100%',
                borderRadius: '14px',
                height: 48,
                padding: '14px 16px',
                '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
              }}
              textStyle={{ color: zeplinColor.Neutral1 }}
              text={'Continue'}
            />
          </Box>
        </CustomCard>
      </Box>
    </CustomModal>
  );
};
